import { get, post } from './apiServices'

const translated = async (language: string) => {
  const response = await get(`/translations?lang=${language}`)
  return response
}

const getLanguages = async () => {
  const response = await get('/get-languages')
  return response
}
const setCommonLanguage = async (language: string) => {
  const response = await post(`/super-admin/locale?locale=${language}`)
  return response
}

const translationService = {
  translated,
  getLanguages,
  setCommonLanguage,
}

export default translationService
